import { SanityPartnerSection } from 'graphql-types';
import React, { useState } from 'react';
import { CommentsPagination } from '../commentsSlider/CommentsPagination';
import { usePageContext } from '../context/pageContext';
import * as styles from './partnerSectionDesktop.module.scss';
import { SwiperSlide } from 'swiper/react';
import Swiper from 'swiper';
import { PartnersSlider } from '../commentsSlider/PartnersSlider';
import { GatsbyImage } from 'gatsby-plugin-image';
import { CommentsSliderDesktopPicture } from '../commentsSlider/CommentsSliderDesktopPicture';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityPartnerSection;
}

export const PartnerSectionDesktop: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();
  const [activeIndex, setActiveIndex] = useState<number>(4);
  const [swiperImage, setSwiperImage] = useState<Swiper | undefined>();
  swiperImage?.on('slideChange', (swiper) => setActiveIndex(swiper.activeIndex));
  return (
    <div className={styles.wrapper}>
      <h2>{findTranslation(section?._rawTitleSection, lang, defaultLang)}</h2>
      <div className={styles.slider}>
        <div className={styles.sliderPicture}>
          <CommentsSliderDesktopPicture
            setSwiper={setSwiperImage}
            initialSlide={1}
            length={section?.imagesList?.length ?? 0}
          >
            {section?.imagesList?.map((image, index) => {
              return (
                <SwiperSlide key={`image-picture-${index}`}>
                  <div
                    id={`INDEX-${index}`}
                    className={`${styles.image} ${activeIndex - 3 === index && styles.active}`}
                  >
                    <GatsbyImage
                      alt={image?.alt ?? ''}
                      image={image?.img?.asset?.gatsbyImageData}
                      objectFit="contain"
                    />
                  </div>
                </SwiperSlide>
              );
            })}
          </CommentsSliderDesktopPicture>
          <div className={styles.pagination}>
            <CommentsPagination
              swiper={swiperImage}
              color={section?.colorNav ?? ''}
              setActiveIndex={setActiveIndex}
              activeIndex={activeIndex}
              length={section?.imagesList?.length}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
